import { useQuery } from '@tanstack/react-query';
import { getAdminUsers } from './getAdminUsers';
import { UserListResponse, UserListRequestPayload } from './types';
import { QUERY_KEY_SETTINGS_ADMIN_PANEL, SETTINGS_QUERY_ALWAYS_REVALIDATE } from '@/lib/api/constants'

type Props = {
  companyId: string
  payload: UserListRequestPayload
}

/**
 * Fetches users list from the API.
 */
export function useQueryAdminUsers(props: Props) {
  const { companyId } = props
  return useQuery<UserListResponse>({
    queryKey: [QUERY_KEY_SETTINGS_ADMIN_PANEL, 'users', companyId, props.payload],
    queryFn: async () => {
      const { data } = await getAdminUsers(props);
      return data;
    },
    ...SETTINGS_QUERY_ALWAYS_REVALIDATE,
  });
}
